import { get } from '@kit/utils/APIV1.js'

export const byID = async(id) => {
  return get(`staff_member/id/${id}`)
}
export const all = async() => {
  return get(`staff_members/all`)
}